// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import DropdownController from "./dropdown_controller"
import SearchController from "./search_controller"
import RegionSearchController from "./region_search_controller"
import CurrencyController from "./currency_controller"
import DateRangeController from "./date_range_controller"
import GuestSelectionController from "./guest_selection_controller"
import SearchFormController from "./search_form_controller"
import NotificationController from "./notification_controller"
import ScrollController from "./scroll_controller"
import ShareController from "./share_controller"
import StickyController from "./sticky_controller"
import ScrollRightController from "./scroll_right_controller"
import BenefitController from "./benefit_controller"
import AmenitiesController from "./amenities_controller"
import GridCardTooltipController from "./grid_card_tooltip_controller"
import NewsletterController from "./newsletter_controller"
import UserController from "./user_controller"
import SmoothScrollController from "./smooth_scroll_controller"
import OembedController from "./oembed_controller"
import CurrencyQueryController from "./currency_query_controller"
import LoadingController from "./loading_controller"
import FaqController from "./faq_controller"
import AccordionController from "./accordion_controller"
import EmblaCarouselController from "./embla_carousel_controller"
import ScrollToTopController from "./scroll_to_top_controller"
import SortDropdownController from "./sort_dropdown_controller"
import FilterDrawerController from "./filter_drawer_controller"
import SouvenirProductController from "./souvenir_product_controller"
import OrderModalController from "./order_modal_controller"
import HotelFilterDrawerController from "./hotel_filter_drawer_controller"
import HotelAvailabilityController from "./hotel_availability_controller"
import TimelineWidthController from "./timeline_width_controller"

application.register("hello", HelloController)
application.register("dropdown", DropdownController)
application.register("search", SearchController)
application.register("region-search", RegionSearchController)
application.register("currency", CurrencyController)
application.register("date-range", DateRangeController)
application.register("guest-selection", GuestSelectionController)
application.register("search-form", SearchFormController)
application.register("notification", NotificationController)
application.register("scroll", ScrollController)
application.register("share", ShareController)
application.register("sticky", StickyController)
application.register("scroll-right", ScrollRightController)
application.register("benefit", BenefitController)
application.register("amenities", AmenitiesController)
application.register("grid-card-tooltip", GridCardTooltipController)
application.register("newsletter", NewsletterController)
application.register("user", UserController)
application.register("smooth-scroll", SmoothScrollController)
application.register("oembed", OembedController)
application.register("currency-query", CurrencyQueryController)
application.register("loading", LoadingController)
application.register("faq", FaqController)
application.register("accordion", AccordionController)
application.register("embla-carousel", EmblaCarouselController)
application.register("scroll-to-top", ScrollToTopController)
application.register("sort-dropdown", SortDropdownController)
application.register("filter-drawer", FilterDrawerController)
application.register("souvenir-product", SouvenirProductController)
application.register("order-modal", OrderModalController)
application.register("hotel-filter-drawer", HotelFilterDrawerController)
application.register("hotel-availability", HotelAvailabilityController)
application.register("timeline-width", TimelineWidthController)

import AiSearchController from "./ai_search_controller"
application.register("ai-search", AiSearchController)